<template>
  <div>
    <title-bar :title-stack="titleStack" />
    <hero-bar>
      Uploaded Data
      <b-button slot="right" type="is-primary" @click="$router.go(-1)">
        <span>Back</span>
      </b-button>
    </hero-bar>
    <section class="section is-main-section">
      <uploaded-data :account-id="Number(userId)"></uploaded-data>
    </section>
  </div>
</template>

<script>
import UploadedData from "@/components/Dashboard/UploadedData.vue";
import TitleBar from "@/components/TitleBar";
import HeroBar from "@/components/HeroBar";
import { mapGetters } from "vuex";

export default {
  name: "ReportingTracker",
  components: { HeroBar, TitleBar, UploadedData },
  computed: {
    ...mapGetters([
      "userId",
      "userName",
      "userHasPermission",
      "userGroups",
      "isUserExternal"
    ]),

    titleStack() {
      return [
        { url: "/", name: "Dashboard" },
        { url: "/dashboard/uploaded-data", name: "Uploaded Data" }
      ];
    }
  }
};
</script>
